"use client";

import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from "react";

import { CoordsProps } from "@/TS/Interfaces/global_interfaces";

export interface DropDownValue {
  setDropData: Dispatch<SetStateAction<DropData | null>>;
  dropData: DropData | null;
}

export interface DropData {
  form: any;
  jsx: ReactNode;
  modalRef: React.RefObject<HTMLDivElement | null>;
  coords: CoordsProps | null;
  isOut: boolean | null;
  isOutBottom: boolean | null;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsOut: Dispatch<SetStateAction<boolean | null>>;
}
export const dropdownModalContext = createContext<DropDownValue>(null!);

function DropdownModalProvider({ children }: { children: ReactNode }) {
  const [dropData, setDropData] = useState<DropData | null>(null);

  return (
    <dropdownModalContext.Provider value={{ setDropData, dropData }}>
      {children}
    </dropdownModalContext.Provider>
  );
}

export default DropdownModalProvider;
